<template>
  <div class="modal_wrap" :class="{ on: isOpen }">
    <!--'on 추가'-->
    <div class="modal_inner" v-if="this.estimationList.content.length > 0">
      <div class="modal">
        <div class="modal_head">
          <h1 class="h1">요청서 선택</h1>
        </div>
        <div class="modal_con">
          <div
            class="request_table radio"
            v-for="(item, index) in this.estimationList.content"
            v-bind:key="index"
          >
            <label
              ><input
                type="radio"
                name="request"
                v-model="selectedEstimation"
                :checked="index === 0"
                :value="index"
              /><span>{{ item.createdAt }} | 휴대폰견적요청서</span></label
            >
            <EstimationCard :item="item"> </EstimationCard>
          </div>
        </div>
        <div class="modal_btn">
          <div class="btn_wrap">
            <button class="btn bo grey" v-on:click="$emit('close')">
              닫기
            </button>
            <button class="btn" @click="sendEstimation">
              요청서 보내기
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal_inner" v-else>
      <div class="modal">
        <div class="modal_head">
          <!--<h1 class="h1"></h1>-->
        </div>
        <div class="modal_con">
          <div class="modal_txt">
            <div class="center">
              <span class="color bold">등록된 요청서가 없습니다.</span><br />
              <br />
              요청서를 등록하신 후<br />
              다시 시도해주세요.
            </div>
          </div>
        </div>
        <div class="modal_btn">
          <div class="btn_wrap">
            <button class="btn bo grey" v-on:click="$emit('close')">
              닫기
            </button>
            <router-link
              :to="{ name: 'Estimation.Create' }"
              tag="button"
              class="btn"
              >요청서 작성하기</router-link
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  mapActions as mapEstimateActions,
  mapGetters as mapEstimateGetters,
} from '@common/store/modules/estimate';
import * as estimationTypes from '@common/store/modules/estimate/types';
import EstimationCard from '@/front/customer/views/estimation/components/EstimationCard';

export default {
  name: 'EstimationListModal',
  components: { EstimationCard },
  data() {
    return {
      isOpen: false,
      selectedEstimation: 0,
      PAGE_SIZE: 100,
      PAGE: 1,
    };
  },
  created() {
    this.getEstimationList();
  },
  computed: {
    ...mapEstimateGetters({
      estimationList: estimationTypes.ESTIMATION_LIST,
    }),
  },
  methods: {
    ...mapEstimateActions([
      estimationTypes.FETCH_ESTIMATION_LIST,
      estimationTypes.DELETE_ESTIMATION,
    ]),
    async getEstimationList() {
      await this[estimationTypes.FETCH_ESTIMATION_LIST]({
        page: this.PAGE,
        size: this.PAGE_SIZE,
        type: 'DEFAULT',
      });
    },
    sendEstimation() {
      const checkedEstimation = this.estimationList.content[
        this.selectedEstimation
      ];
      this.$emit('sendEstimation', checkedEstimation);
    },
  },
};
</script>
